import { toast } from "sonner";
import { useAuthStore } from "@/modules/auth";
import { useChannel } from "@/modules/realtime";

export function ForceLogoutListener() {
  const userId = useAuthStore((s) => s.user?.id);
  const forceLogout = useAuthStore((s) => s.forceLogout);

  useChannel(userId ? `user.${userId}` : null, {
    "auth.force_logout": (payload: { reason?: string }) => {
      toast.error(`Session ended: ${payload?.reason ?? "force_logout"}. Please sign in again.`);
      forceLogout();
      window.location.assign("/login");
    },
    "auth.version_bumped": () => {
      // Token will be invalidated server-side; gracefully drop session.
      forceLogout();
      window.location.assign("/login");
    },
  });

  return null;
}
